module.exports = __webpack_public_path__ + "static/media/kasumin.c6e5cd74.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/xanthomonas_tomate/curativa/kasumin.png
// module id = 2404
// module chunks = 3